import axios from 'axios';
import { MDBAutocomplete, MDBBadge, MDBBtn, MDBIcon, MDBInputGroup } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

function DemoSearch({ setFormData, refreshCompanyList, setInitialName }) {
  const [demoSummaries, setDemoSummaries] = useState([]);
  const [filteredNames, setFilteredNames] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;

  const fetchSummaries = useCallback(async () => {
    try {
      const response = await axios.get(`${baseUrl}/demo/summary`);
      const data = response.data;

      if (Array.isArray(data)) {
        setDemoSummaries(data);
        setFilteredNames(data.map(demo => demo.companyName));
      } else {
        setDemoSummaries([]);
        setFilteredNames([]);
      }
    } catch (error) {
      console.error('Error fetching demo summaries:', error);
      setDemoSummaries([]);
      setFilteredNames([]);
    }
  }, [baseUrl]);

  useEffect(() => {
    fetchSummaries();
  }, [fetchSummaries]);

  useEffect(() => {
    if (selectedId !== null) {
      const fetchDemo = async () => {
        try {
          const response = await axios.get(`${baseUrl}/demo/${selectedId}`);
          setFormData(response.data);
          setInitialName(response.data.demoUser?.companyName || '');
        } catch (error) {
          console.error('Error fetching demo:', error);
        }
      };
      fetchDemo();
    }
  }, [selectedId, baseUrl, setFormData]);

  useEffect(() => {
    refreshCompanyList.current = fetchSummaries;
  }, [refreshCompanyList, fetchSummaries]);

  const handleSearch = (value) => {
    // If the input is empty, reset the filtered names to the full list
    if (!value) {
      setFilteredNames(demoSummaries.map(demo => demo.companyName));
      setSelectedId(null);
      return;
    }

    const filtered = demoSummaries
      .filter(demo => demo.companyName.toLowerCase().includes(value.toLowerCase()))
      .map(demo => demo.companyName);

    setFilteredNames(filtered);

    // Check if there's an exact match
    const matchedDemo = demoSummaries.find(demo => demo.companyName.toLowerCase() === value.toLowerCase());
    if (matchedDemo) {
      setSelectedId(matchedDemo.id);
    }
  };

  return (
    <MDBInputGroup>
      <MDBAutocomplete
        label='Select a Company'
        data={filteredNames}
        onChange={(value) => handleSearch(value)} // Use `getValue` directly for handling changes
        placeholder="Start typing to search..."
      />
      <MDBBtn rippleColor='white' style={{ position: 'relative' }}>
        <span>
          <MDBIcon fas icon='search' />
        </span>
        <span style={{ position: 'absolute', top: 0, right: 0 }}>
          <MDBBadge color='danger' notification pill>
            {filteredNames.length}
          </MDBBadge>
        </span>
      </MDBBtn>
    </MDBInputGroup>
  );
}

DemoSearch.propTypes = {
  setFormData: PropTypes.func.isRequired,
  refreshCompanyList: PropTypes.object.isRequired,
  setInitialName: PropTypes.func.isRequired,
};

export default DemoSearch;
